import styles from "./FaktioBrand.module.css";

/** Wordmark for the sidebar and the login card: the red mark + "faktio". */
export function FaktioBrand() {
  return (
    <span className={styles.brand}>
      <FaktioMark />
      <span className={styles.word}>faktio</span>
    </span>
  );
}

/** The mark alone — what reads when the sidebar collapses to a rail. */
export function FaktioMark() {
  return (
    <svg className={styles.mark} viewBox="0 0 24 24" aria-hidden="true">
      <rect width="24" height="24" rx="6" fill="var(--faktio-brand-red)" />
      <path d="M8 6h9v3h-5.5v2.5H16v3h-4.5V18H8z" fill="#fff" />
    </svg>
  );
}
